export const aspectRation = (315 + 35) / 232;
export const widthCard = 195;
export const isLocal = false;
export const serverUrl = isLocal
  ? "http://localhost:8080"
  : "https://indyx-server-3tg67jmjeq-uc.a.run.app";

export const cachedSellerNameKey = "CACHED_SELLER_NAME_KEY";
